// Library
import React, { useContext, useEffect, useState } from "react";
import { Typography, Stack, Tooltip, Switch, CircularProgress, Box } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline"; // Envelope icon
import { useLazyQuery, useMutation } from "@apollo/client";
import { notify } from "../../../Common/notify";

// Local
import { GET_SUBSCRIPTION_STATUS, SET_TOGGLE_SUBSCRIPTIONS } from '../../../Queries';
import { DocumentContext } from "../../DocumentContext";

const SubscriptionToggle = () => {
  const context = useContext(DocumentContext);
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Lazy query: Get current subscription status
  const [getToggleSubscriptionStatus] = useLazyQuery(GET_SUBSCRIPTION_STATUS, {
    fetchPolicy: 'network-only',
    variables: { doc_id: context.documentId },
    onCompleted: (data) => {

      setSubscribed(data.getToggleSubscriptions.response);
      setLoading(false);
    },
    onError: (err) => {
      setError(err.message);
      notify("Failed to load subscription status");
      setLoading(false);
    },
  });

  // Dummy toggle function (temporary stand-in for mutation)
  const toggleSubscriptionFunction = () => {
    const newStatus = !subscribed;
    toggleSubscription({
      variables: {
        doc_id: context.documentId,
        toggleSubscriptions: newStatus
      }
    })
    setSubscribed(newStatus);
    // notify(newStatus ? "Subscription activated!" : "Subscription deactivated.");
  };


  const [toggleSubscription] = useMutation(SET_TOGGLE_SUBSCRIPTIONS, {
    fetchPolicy: 'network-only',
    onCompleted: () => {
      setLoading(false);
    },
    onError: (err) => {
      setLoading(false);
      setError(err.message);
    }
  })

  useEffect(() => {
    setLoading(true);
    getToggleSubscriptionStatus();
  }, [getToggleSubscriptionStatus]);

  const label = subscribed ? "Deactivate Subscription" : "Activate Subscription";

  if (loading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", height: "60px" }}>
        <CircularProgress size={24} />
        <Typography sx={{ ml: 2 }}>Loading subscription status...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error">Error loading subscription status: {error}</Typography>
    );
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        justifyContent: "flex-start",
        border: "none",
        width: "100%",
        textTransform: "none",
        marginTop: "0px",
        marginLeft: "4px",
      }}
    >
      {/* Envelope Icon */}
      <MailOutlineIcon fontSize="small" sx={{ marginRight: "8px" }} />

      {/* Label */}
      <Typography variant="body1" sx={{ marginRight: "8px" }}>
        {label}
      </Typography>

      {/* Toggle */}
      <Tooltip title={label}>
        <Switch
          checked={subscribed}
          onChange={toggleSubscriptionFunction}
          color="default"
          inputProps={{ "aria-label": label }}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: "cornflowerblue",
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "cornflowerblue",
            },
          }}
        />
      </Tooltip>
    </Stack>
  );
};

export default SubscriptionToggle;
